import { SVGProps } from 'react';
const BasicPlanIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={256} height={256} viewBox="0 0 256 256" fill="none" {...props}>
        <path
            fill="currentColor"
            stroke="currentColor"
            strokeWidth={8}
            d="M60 112a15.998 15.998 0 0 1 16 16l-.01.593a16.004 16.004 0 0 1-9.867 14.189 15.994 15.994 0 0 1-17.437-3.469 15.996 15.996 0 0 1-3.468-17.436A16 16 0 0 1 60 112ZM196 112c4.243 0 8.313 1.686 11.313 4.687 3.001 3 4.687 7.07 4.687 11.313l-.011.593a15.998 15.998 0 0 1-27.302 10.72 15.99 15.99 0 0 1-4.379-8.192 15.993 15.993 0 0 1 6.803-16.425A16 16 0 0 1 196 112Z"
            opacity={0.2}
        />
        <path
            fill="currentColor"
            stroke="currentColor"
            strokeWidth={8}
            d="M128 112c4.243 0 8.313 1.686 11.313 4.687 3.001 3 4.687 7.07 4.687 11.313l-.011.593a15.998 15.998 0 0 1-27.302 10.72 15.99 15.99 0 0 1-4.379-8.192 15.993 15.993 0 0 1 6.803-16.425A16 16 0 0 1 128 112Z"
        />
        <path
            fill="currentColor"
            stroke="currentColor"
            strokeWidth={8}
            d="M60 40a16 16 0 0 1 16 16l-.01.593A16 16 0 1 1 60 40ZM196 40a15.998 15.998 0 0 1 16 16l-.011.593a15.995 15.995 0 0 1-9.866 14.19 15.998 15.998 0 0 1-21.815-11.662 15.994 15.994 0 0 1 6.803-16.425A16.002 16.002 0 0 1 196 40ZM128 40a15.998 15.998 0 0 1 16 16l-.011.593a15.995 15.995 0 0 1-9.866 14.19 15.998 15.998 0 0 1-21.815-11.662 15.994 15.994 0 0 1 6.803-16.425A16.002 16.002 0 0 1 128 40ZM60 184a15.998 15.998 0 0 1 16 16l-.01.593a16.004 16.004 0 0 1-9.867 14.189 15.994 15.994 0 0 1-17.437-3.469 15.996 15.996 0 0 1-3.468-17.436A16 16 0 0 1 60 184ZM196 184c4.243 0 8.313 1.686 11.313 4.687 3.001 3 4.687 7.07 4.687 11.313l-.011.593a15.998 15.998 0 0 1-27.302 10.72 15.99 15.99 0 0 1-4.379-8.192 15.993 15.993 0 0 1 6.803-16.425A16 16 0 0 1 196 184ZM128 184c4.243 0 8.313 1.686 11.313 4.687 3.001 3 4.687 7.07 4.687 11.313l-.011.593a15.998 15.998 0 0 1-27.302 10.72 15.99 15.99 0 0 1-4.379-8.192 15.993 15.993 0 0 1 6.803-16.425A16 16 0 0 1 128 184Z"
            opacity={0.2}
        />
    </svg>
);
export default BasicPlanIcon;
